import { render, staticRenderFns } from "./BorrarCodigoModal.vue?vue&type=template&id=fb437d5e"
import script from "./BorrarCodigoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BorrarCodigoModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports